module.exports = __webpack_public_path__ + "img/3Computers-1536x748-V2.7202ea49.jpg";